import { Button, Box, Typography, Badge } from '@material-ui/core';
import { Link } from 'components';
import { useTranslation } from 'react-i18next';
import React from 'react';
import { useStyles } from './menu-items.style';
import WorkIcon from '@material-ui/icons/Work';
import BookmarksIcon from '@material-ui/icons/Bookmarks';
import SettingsIcon from '@material-ui/icons/Settings';
import { ReactComponent as BCIcon } from 'assets/bc.svg';
import SpeakerNotesIcon from '@material-ui/icons/SpeakerNotes';
import { useNotificationsCount } from '@mediusoft/matrix-chat';
import { useAuth } from 'context/AuthContext';

const MessageIconWithBadge = () => {
    const allUnreadNotificationsCount = useNotificationsCount();

    return (
        <Badge badgeContent={allUnreadNotificationsCount} color="primary">
            <SpeakerNotesIcon />
        </Badge>
    );
};

export const JobseekerMenuItems: React.FC<{ handleClose?: () => void }> = ({ handleClose }) => {
    const classes = useStyles();
    const { t } = useTranslation();

    const { user } = useAuth();
    const matrixAuth = user?.matrixAuth;

    const menuItems = [
        {
            title: t('mainProfileMenu:myApplications'),
            icon: <WorkIcon />,
            route: '/d/application/list',
        },
        {
            title: t('mainProfileMenu:myBookmarks'),
            icon: <BookmarksIcon />,
            route: '/d/bookmarks',
        },
        {
            title: t('mainProfileMenu:messages'),
            icon: matrixAuth ? <MessageIconWithBadge /> : <SpeakerNotesIcon />,
            route: '/d/messages',
        },
        {
            title: t('mainProfileMenu:businessCard'),
            icon: <BCIcon className={classes.bc} />,
            route: '/bc',
        },
        {
            title: t('mainProfileMenu:settings'),
            icon: <SettingsIcon />,
            route: '/d/settings',
        },
    ];
    return (
        <>
            {menuItems.map((item, index) => (
                <Link key={index} to={item.route}>
                    <Button
                        onClick={handleClose}
                        startIcon={<Box className={classes.iconContainer}>{item.icon}</Box>}
                        className={classes.userMenuItem}
                    >
                        <Typography className={classes.userMenuItemText}>{item.title}</Typography>
                    </Button>
                </Link>
            ))}
        </>
    );
};
